import React from "react";
import { Spin } from "antd";

import Icon from "shared/components/Icon";

interface PendingStatusCardProps {
  message: string;
  className?: string;
}

const PendingStatusCard: React.FC<PendingStatusCardProps> = ({
  message,
  className,
}) => {
  return (
    <div
      className={className}
      style={{ textAlign: "center", padding: "20px" }}
    >
      <div style={{ marginBottom: "12px" }}>
        <Icon.LoadingSpinnerIcon width={24} height={24} />
      </div>
      <div
        style={{
          fontSize: "14px",
          color: "#666",
          marginBottom: "8px",
        }}
      >
        {message}
      </div>
      <div style={{ fontSize: "12px", color: "#999" }}>
        <Spin size="small" />
        <span style={{ marginLeft: "8px" }}>Processing...</span>
      </div>
    </div>
  );
};

export default PendingStatusCard;
